import { ServiceType } from '../../../global/api/models';
import {
    serviceRequest,
    getApiHost,
} from '../../../global/api/public/utils';
import { TimeZoneString } from '../../../global/models';
import {
    GivingPaymentHistory,
    GivingPaymentHistoryExportRequestParameters,
} from '../givingHistory/models';

export const getAvailableStatementYears = async (
    accessToken: string,
    timeZone: TimeZoneString,
    includeSpouseGiving: boolean,
): Promise<number[]> => {
    const { data } = await serviceRequest({
        accessToken,
        method: 'GET',
        url: `${getApiHost(ServiceType.Core)}/api/v4/giving/insights/my-giving-statements/available-years?timeZone=${timeZone}&includeSpouseGiving=${includeSpouseGiving}`,
    });

    return data as number[];
};

export const getGivingPaymentHistory = async (
    accessToken: string,
    searchQuery: string,
): Promise<GivingPaymentHistory> => {
    const { data } = await serviceRequest({
        accessToken,
        method: 'GET',
        url: `${getApiHost(ServiceType.Core)}/api/v4/giving/insights/my-giving-history?${searchQuery}`,
    });

    return data as GivingPaymentHistory;
};

export const requestGivingStatement = async (
    accessToken: string,
    year: number,
    timeZone: TimeZoneString,
    includeSpouseGiving: boolean,
): Promise<any> => {
    const { data } = await serviceRequest({
        accessToken,
        data: {
            includeSpouseGiving,
            timeZone,
            year,
        },
        method: 'POST',
        url: `${getApiHost(ServiceType.Core)}/api/v4/giving/insights/my-giving-statements`,
    });

    return data;
};

export const requestGivingExcelDataExport = async (
    accessToken: string,
    parameters: GivingPaymentHistoryExportRequestParameters,
): Promise<any> => {
    // TODO: Update to use a Core v4 API endpoint (once back-end work has been done)

    const { data } = await serviceRequest({
        accessToken,
        data: parameters,
        method: 'POST',
        url: `${getApiHost(ServiceType.Giving)}/api/giving/insights/payment-history/request-export`,
    });

    return data;
};

export const requestExportStatus = async (
    accessToken: string,
    id: number,
): Promise<any> => {
    const { data } = await serviceRequest({
        accessToken,
        method: 'GET',
        url: `${getApiHost(ServiceType.Core)}/api/export/${id}/status`,
    });

    return data;
};
